import { useFormikContext } from 'formik'
import { IRole } from '../types'

export function useRoleFormContext() {
  return useFormikContext<IRole>()
}
